<template>
  <div class="api-out-body">
    <template v-if="bodyType === 'html'">
      <span class="text-muted">
        HTML page detected
        <a
          href="#"
          data-toggle="modal"
          :data-target="'#htmlModal' + uid"
          @click.prevent
        >
          (click to view)
        </a>
      </span>
      <div
        :id="'htmlModal' + uid"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-xl"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body px-5">
              <iframe :srcdoc="text" class="api-out-body__iframe" sandbox="" />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="bodyType === 'xml'">
      <pre class="hljs-pre"><code v-dompurify-html="highlightedXml" /></pre>
    </template>

    <template v-else-if="bodyType === 'json'">
      <pre class="hljs-pre"><code v-dompurify-html="highlightedJson" /></pre>
    </template>

    <template v-else>
      {{ text }}
    </template>
  </div>
</template>

<script>
import xmlbeautify from "xml-beautifier";
import hljs from "highlight.js/lib/core";
import xml from "highlight.js/lib/languages/xml";
import json from "highlight.js/lib/languages/json";

hljs.registerLanguage("xml", xml);
hljs.registerLanguage("json", json);

let nextUid = 0;

export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uid: nextUid++,
    };
  },
  computed: {
    bodyType() {
      if (!this.text) {
        return "text";
      }

      const trimmed = this.text.trim();

      if (trimmed.startsWith("<!DOCTYPE") || trimmed.startsWith("<html")) {
        return "html";
      }

      if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
        try {
          JSON.parse(trimmed);
          return "json";
        } catch {
          return "text";
        }
      }

      if (trimmed.startsWith("<") && trimmed.endsWith(">")) {
        return "xml";
      }

      return "text";
    },
    highlightedJson() {
      try {
        const formatted = JSON.stringify(JSON.parse(this.text.trim()), null, 2);
        return hljs.highlight(formatted, { language: "json" }).value;
      } catch {
        return this.text;
      }
    },
    highlightedXml() {
      const beautified = xmlbeautify(this.text);
      return hljs.highlight(beautified, { language: "xml" }).value;
    },
  },
};
</script>

<style scoped>
.api-out-body__iframe {
  width: 100%;
  height: 400px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
</style>
